export default __webpack_public_path__ + "static/media/4.0e38d3d3.jpg";